import React, { useState, useEffect } from "react";
import Header from "./Header";
import {
  activityData,
  destinationData,
  genderData,
  tableData,
} from "./data/Mockdata";
import StatsCard from "./StatsCard";
import PackingTable from "./PackingTable";
import ChartCard from "./ChartCard";
import GenderChart from "./GenderChart";
import ActivityChart from "./ActivityChart";
import DestinationChart from "./DestinationChart";

import {
  useLazyGetPackingListSearchQuery,
  useLazyGetPackingListStatsCardQuery,
} from "../../../../services/Api";
import { Pagination } from "../../../../components/Pagination";
import ListImage from "../../../../assets/ListImage.png";
import Suitcase from "../../../../assets/Suitcase.png";
import Worldwide from "../../../../assets/Worldwide.png";
import Report from "../../../../assets/Report.png";
import Crown1 from "../../../../assets/Crown.png";
import OrderedbySaves from "./OrderedbySaves";
import { Link } from "react-router-dom";
import PackingStyleDistributionPacking from './packingStyleDis'

function Packing() {
  const [currentPage, setCurrentPage] = useState(1);
  // Trigger the query whenever the page changes
  useEffect(() => {
    trigger({ page: currentPage });
  }, [currentPage]);
  const [addList, setAddList] = useState(false);
  const [trigger, { data, isLoading, error }] =
    useLazyGetPackingListSearchQuery();
  useEffect(() => {
    trigger();
  }, []);
  const totalPages = data?.data?.totalPages || 1;

  const [
    triggerData,
    { data: statData, isLoading: statLoading, error: statError },
  ] = useLazyGetPackingListStatsCardQuery();

  useEffect(() => {
    triggerData();
  }, [triggerData]);

  const stats = {
    totalPackingLists: statData?.data?.totalPackingLists || 0,
    activePackingLists: statData?.data?.activePackingLists || 0,
    regularPackingLists: statData?.data?.regularPackingLists || 0,
    proPackingLists: statData?.data?.proPackingLists || 0,
    destinationsCovered: statData?.data?.destinationsCovered || 0,
  };

  const statsData = [
    {
      title: "Total Packing Lists",
      value: stats?.totalPackingLists,
      icon: ListImage,
      bgColor: "bg-bgprimary",
      isFirst: true,
    },
    {
      title: "Regular Packing Lists",
      value: stats?.regularPackingLists,
      icon: Report,
      bgColor: "bg-white",
    },
    {
      title: "PRO Packing Lists",
      value: stats?.proPackingLists,
      icon: Crown1,
      bgColor: "bg-white",
    },
    {
      title: "Destinations Covered",
      value: stats?.destinationsCovered,
      icon: Worldwide,
      bgColor: "bg-white",
    },
  ];

  return (
    <div className="min-h-screen p-4 md:p-8">
      <div className="flex justify-between md:flex-row flex-col md:items-center gap-4">
        <Header
          title="Packing Lists"
          description="Monitor and manage all packing lists created by travelers"
        />
        <div className="md:mb-0 mb-4">
          <Link
            to={"/addpackinglist"}
            className="flex items-center gap-3 w-fit bg-bgprimary rounded-lg px-5 py-2 font-quicksand text-black font-semibold text-[14px]"
          >
            + Add New
          </Link>
        </div>
      </div>

      {/* Updated Stats Grid to fit 4 cards in one row */}
      <div className="grid grid-cols-1 md:grid-cols-4 gap-4 mb-8">
        {statsData.map((stat, index) => (
          <StatsCard key={index} {...stat} />
        ))}
      </div>

      <div className="grid grid-cols-1 md:grid-cols-4 gap-6 mb-8">
        <ChartCard title="Gender Distribution">
          <GenderChart data={genderData} />
        </ChartCard>
        <ChartCard title="Activity Distribution">
          <ActivityChart data={activityData} />
        </ChartCard>
        <ChartCard title="Destination Region Distribution">
          <DestinationChart data={destinationData} />
        </ChartCard>
        <ChartCard title="Packing Style Distribution">
          <PackingStyleDistributionPacking />

        </ChartCard>
      </div>

      <div className="grid md:grid-cols-2">
        <div className="md:col-span-2 bg-white p-6 rounded-[1.75rem] shadow-md mb-4 md:mb-0 h-fit overflow-x-auto">
          <h2 className="mb-4 font-['Roboto_Mono'] text-2xl font-bold">
            Packing List Table
          </h2>
          <div className="overflow-x-auto">
            <PackingTable data={data} loading={isLoading} trigger={trigger} />
            <div className="overflow-x-auto">
              <Pagination
                totalPages={data?.pagination?.totalPages}
                currentPage={currentPage}
                onPageChange={setCurrentPage}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );

}

export default Packing;
